import {Component} from 'preact';
import classNames from "classnames";

import TextInput from '../form/TextInput';
import SelectInput from '../form/SelectInput';
import CheckboxInput from '../form/CheckboxInput';
import ConsentLink from '../blocks/raffleForm/ConsentLink';
import LoadingSpinner from '../spinner/LoadingSpinner';

import Validator from "../form/Validators";

import styles from "./styles.scss";

class SubscribeForm extends Component {

    get consent() {
        const {consents, openConsentModal} = this.props;

        return <ConsentLink
            textBeforeLink=' I agree with having my'
            linkText=' personal data processed '
            textAfterLink="for marketing purposes. (Don't worry, we're not the Big Brother)"
            openConsentModal={openConsentModal}
            consent={consents[0]}
        />
    }

    get Checkbox() {
        const {checkbox, onCheckboxClick} = this.props;

        return <CheckboxInput
            name='checkbox'
            required={true}
            value={checkbox.value}
            touched={checkbox.touched}
            onChangeAction={onCheckboxClick}
            label={this.consent}
            invalidMessage='You must agree'
        />
    }

    get SubscribeButton() {
        const {subscribe} = this.props;
        return <button className={styles.button} onClick={subscribe}>
            Subscribe
            <span className={styles.arrow}/>
        </button>
    }

    get isTouched() {
        const {email, country} = this.props;
        return email.touched === true || country.touched === true;
    }

    render({countries, consents, email, country, isMobile, onTextInputClick, onCountryChange}) {

        if(!countries || !consents) {
            return <LoadingSpinner className={styles.spinner} active />;
        }

        return (
            <div className={styles.innerContainer}>
                <div className={classNames(styles.inputsContainer, {
                    [styles.customMargin]: this.isTouched
                })}>
                    <TextInput
                        name='email'
                        placeholder='Your e-mail address'
                        autocomplete='email'
                        required={true}
                        valid={email.valid}
                        value={email.value}
                        touched={email.touched}
                        errors={email.errors}
                        validators={[
                            new Validator('isEmail', 'email')
                        ]}
                        onChangeAction={onTextInputClick}
                    />
                    <SelectInput
                        name='country'
                        required={true}
                        value={country.value}
                        touched={country.touched}
                        invalidMessage='Please select a country'
                        placeholder='Choose your country'
                        options={countries}
                        className='subscribe-select'
                        onChangeAction={onCountryChange}
                    />
                    {isMobile ? this.Checkbox : this.SubscribeButton}
                </div>
                {!isMobile ? this.Checkbox : this.SubscribeButton}
            </div>
        )
    }
}

export default SubscribeForm;



// WEBPACK FOOTER //
// ./components/subscribe/SubscribeForm.js